let PackagesItem = [
    {
        id: 1,
        trackTitle: "Senior Track 🔥",
        trackSubtitle: "For Senior developers, CTOs and Founders",
        trackPrice: "$99",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'Full Access to Q&A sessions',
        trackLink: 'https://geekle.us/ticket/1675699323957x469292402673713150',
    },
    {
        id: 2,
        trackTitle: "Junior Track",
        trackSubtitle: "For Junior developers",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Live Q&A panels from a Junior Track',
        trackLink: 'https://geekle.us/ticketfree/1675699623903x887689248045269000',
    },
];

export default PackagesItem;
